<template>
  <li
    v-if="type === 'first'"
    class="pagination-item"
    :class="{ disabled: disabled }"
    @click="onClick"
  >
    <span aria-hidden="true">&laquo;</span>
  </li>
  <li
    v-else-if="type === 'last'"
    class="pagination-item"
    :class="{ disabled: disabled }"
    @click="onClick"
  >
    <span aria-hidden="true">&raquo;</span>
  </li>
  <li
    v-else
    class="pagination-item"
    :class="{ active: active, readOnly: readOnly }"
    @click="onClick"
  >
    {{ pageNum }}
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaginationItem',
  props: {
    type: String,
    pageNum: [Number, String],
    disabled: Boolean,
    active: Boolean,
    readOnly: Boolean,
  },
  emits: ['click'],
  setup(props, { emit }) {
    const onClick = () => {
      emit('click');
    };

    return {
      onClick,
    };
  },
});
</script>

<style lang="scss">
.pagination-item {
  padding: var(--space-1) var(--space-3);
  border-right: 1px solid var(--grey-light);
  color: var(--blue);

  &.active {
    background-color: var(--white);
    font-family: var(--font-bold);
    color: var(--white) !important;
    background-color: var(--blue);
  }

  &:last-child {
    border-right: 0;
  }

  &:hover {
    cursor: pointer;
  }

  &.disabled {
    color: var(--grey);
    background-color: var(--grey-ultra-light);
    cursor: initial;
  }

  &.readOnly {
    cursor: initial;
  }
}
</style>
